export * from 'axios';
import axios from 'axios';
import env from '@beam-australia/react-env';

export const newCheckoutInstance = axios.create({
    baseURL: env('LAMBDA_URL'),
});
